module.exports = __webpack_public_path__ + "img/ski7.1c94c5fd.jpg";